export const SOURCE_TEXT_CONFIGURATION_CASE = "sourceText";

export const SOURCE_TEXT_MAX_CHARACTERS_LENGTH = 20000;

export const CREATE_SOURCE_TEXT_CONTENT_REQUIRED_ERROR = "Text content is required";
export const CREATE_SOURCE_TEXT_CONTENT_MAX_LENGTH_ERROR = `Text content must not exceed ${SOURCE_TEXT_MAX_CHARACTERS_LENGTH.toLocaleString()} characters`;
